import { render, staticRenderFns } from "./SaleHistoryNew.vue?vue&type=template&id=21186e63&scoped=true"
import script from "./SaleHistoryNew.vue?vue&type=script&lang=js"
export * from "./SaleHistoryNew.vue?vue&type=script&lang=js"
import style0 from "./SaleHistoryNew.vue?vue&type=style&index=0&id=21186e63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21186e63",
  null
  
)

export default component.exports